import { ChevronRightIcon } from '@heroicons/react/24/outline';
import { useNavigate } from 'react-router-dom';
import { Avatar } from '../../../Avatar';

interface OrthodontistFormHeaderProps {
    isSaving: boolean;
    canCreate: boolean;
    onCreate: () => void;
}

// Lean sibling to practice/create/PracticeFormHeader - same breadcrumb/Cancel/
// primary-button chrome, without the dirty-tracking indicator or its guard.
export function OrthodontistFormHeader({
    isSaving,
    canCreate,
    onCreate
}: OrthodontistFormHeaderProps) {
    const navigate = useNavigate();
    const crumbs = [
        { label: 'Accounts', path: '/accounts/orthodontists' },
        { label: 'Orthodontists', path: '/accounts/orthodontists' },
        { label: 'New orthodontist', path: null }
    ];

    return (
        <div className="flex items-center justify-between px-8 pt-4 pb-2 shrink-0 gap-4">
            <div className="flex items-center gap-1.5 text-[13px] text-gray-500 min-w-0">
                {crumbs.map((crumb, i) => (
                    <span key={crumb.label} className="flex items-center gap-1.5 min-w-0">
                        {i > 0 && <ChevronRightIcon className="h-3 w-3 text-gray-300 shrink-0" />}
                        {crumb.path ? (
                            <button
                                type="button"
                                onClick={() => navigate(crumb.path as string)}
                                className="hover:text-gray-800 transition-colors truncate"
                            >
                                {crumb.label}
                            </button>
                        ) : (
                            <span className="font-semibold text-gray-700 truncate">
                                {crumb.label}
                            </span>
                        )}
                    </span>
                ))}
            </div>
            <div className="flex items-center gap-4 shrink-0">
                {isSaving && (
                    <span className="flex items-center gap-2 text-[13px] font-semibold text-gray-500">
                        <span className="h-3.5 w-3.5 rounded-full border-2 border-gray-300 border-t-gray-600 animate-spin" />
                        Creating…
                    </span>
                )}
                <button
                    type="button"
                    onClick={() => navigate('/accounts/orthodontists')}
                    disabled={isSaving}
                    className="text-sm font-semibold text-gray-500 hover:text-gray-800 px-3 h-9 disabled:opacity-50"
                >
                    Cancel
                </button>
                <button
                    type="button"
                    onClick={onCreate}
                    disabled={!canCreate}
                    className="flex items-center gap-2 bg-black text-white font-semibold px-5 h-9 rounded-lg text-sm hover:bg-gray-900 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                >
                    Create orthodontist
                </button>
                <div className="w-10 h-10">
                    <Avatar />
                </div>
            </div>
        </div>
    );
}
